import React, { useEffect, useCallback, useState} from 'react';
import PMinMaxEditor from './PMinMaxEditor.js';
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';
const colors = new Colors();

const DeviceParameter = ({
    value,
    setSelected,
    selected,
    setParameter,
    parameter,
    parameterSelected,
    depth,
    isBoundsMode,
    max,
    min
}) => { 
    let p = parameter;
    const ungroupParam = useCallback((param) => {
        param.hasGroup.ungroupParameter(param);
        setSelected(selected.filter(x => x !== param));
    }, [setSelected, selected]);

    if (value < 10) {
        value = Math.round(value*1000)/1000.0;
    } else if (parameter.max - parameter.min >= 1000) {
        // then just round
        value = Math.round(value);
    } else if (parameter.max - parameter.min >= 100) {
        value = Math.round(value*10)/10.0;
    } else {
        value = Math.round(value*100)/100.0;

    }

    depth = Math.round(depth*100)/100.0;
    return (
        <div
          onClick={() => setSelected([p])}
          id={parameterSelected === p ? "accumulator-map-source" : ""}
          className={p.locked2D ? "device-parameter locked" : "device-parameter"}>
          <div
            onClick={() => setParameter(p === parameterSelected ? undefined : p)}
            className="dot" style={{
                backgroundColor: colors.getColorForHash(p.name)
            }}></div>
          <div
            className="d-parameter-name">{p.name}</div>
          {!isBoundsMode ?
           <div className="d-parameter-value">{value}</div> :
           <PMinMaxEditor arg="min" label="Min" parameter={parameter}/>
          }
          {!isBoundsMode ?
           <div className="d-parameter-depth">{depth}</div> :
           <PMinMaxEditor arg="max" label="Max" parameter={parameter}/>}
          {p.hasGroup && !isBoundsMode ?
           <div
             onClick={() => ungroupParam(p)}
             className="ungroup-parameter">Ungroup</div> : ''}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      value: props.parameter.get(true),
      depth: props.parameter._depth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceParameter);
